export const SHOW_LOADING = "SHOW_LOADING";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const UPDATE_USER = 'UPDATE_USER';